module.exports = __webpack_public_path__ + "img/fun9.72271c3a.png";